module.exports = __webpack_public_path__ + "media/images/auto-grow-flow-diagram-vertical-padded-96e22d6c.png";